import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

/**
 * 📄 Obtener el pago final del documento (si existe)
 */
export const getExpensePayment = async (documentId) => {
  const res = await axios.get(`${API_URL}/api/expenses/${documentId}/payment`, {
    headers: authHeaders(),
  });
  return res.data; // puede ser null
};

/**
 * 💸 Registrar pago final y cerrar documento
 */
export const payExpenseDocument = async (documentId, data = {}) => {
  const res = await axios.post(
    `${API_URL}/api/expenses/${documentId}/pay`,
    data,
    { headers: authHeaders() }
  );
  return res.data;
};
